/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { createContext } from 'react';

export const NOOP_COMMAND_INTELLIGENCE_ACTIONS = {
  openList: () => {},
  openItem: () => {},
};

export const CommandIntelligenceScreenContext = createContext(null);
